import PageData from "../../../common/ts/PageData";
import InternalStatsTracker from "../../../common/ts/InternalStatsTracker";

const internalStatsApplyImpressionTrackedClass = "js-wl-track-applyimpression";

export default class HipflatInternalStatsTracker {
    private readonly pageData: PageData;
    private internalStatsTracker

    static track(pageData: PageData) {
        return new HipflatInternalStatsTracker(pageData);
    }


    constructor(pageData: PageData) {
        this.pageData = pageData;
        this.internalStatsTracker = new InternalStatsTracker();
        this.trackApplyImpressions()
    }

    public trackApplyImpressions() {
        const applyImpressionTrackedElements = (Array.from(document.getElementsByClassName(internalStatsApplyImpressionTrackedClass)) as HTMLElement[])
            .filter((element) => this.isVisible(element));
        this.internalStatsTracker.trackApplyImpressions(this.pageData, applyImpressionTrackedElements);
    }

    /*
    There is a wonderful method that checks html element visibility but the current browser compatibility is not high enough:
    https://caniuse.com/mdn-api_element_checkvisibility
     */
    private isVisible(element: HTMLElement) {
        return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
    }
}
